<template>
  <div class="wrapper">
    <div class="content">
      <h1 class="mt-1">About</h1>
      <div class="marker"></div>

      <p>
        <strong>aec.works</strong>
        is a curated list of innovative AEC companies and startups.
      </p>

      <h2>How we got started</h2>
      <p>
        Sometime in 2019, Gui Talarico started a list of companies he thought were doing interesting
        things in AEC. As the list grew, he felt it could be valuable to others.
        <a href="https://AecStartups.com">AecStartups.com</a>
        was born ✨
      </p>
      <p>
        As its popularity grew, so did the number of submissions. Since everything was managed
        through Airtable, the whole process was time-consuming and error-prone.
      </p>
      <p>
        <strong>aec.works</strong>
        began in 2020 as the successor of AecStartups. It includes some notable improvements:
      </p>
      <ul class="mt-2 mb-2">
        <li class="ml-1">
          <p>
            • New and improved entries, totaling more than 150 companies with sleek cover images and
            logos.
          </p>
        </li>
        <li class="ml-1">
          <p>• Streamlined tooling to edit content, including non-destructive revisions.</p>
        </li>
        <li class="ml-1">
          <p>
            • A more interactive and engaging interface, including the ability to comment and clap
            (upvote).
          </p>
        </li>
        <li class="ml-1">
          <p>
            •
            <a href="https://github.com/orgs/aecworks/projects/1">Many more planned</a>
            features yet to be built!
          </p>
        </li>
      </ul>

      <h2>Project Contributors</h2>

      <p>
        <strong>aec.works</strong>
        is a collaborative effort from several people in the AEC technology industry. The project is
        open source and licensed under GNU GPLv3.
      </p>

      <h3 class="mb-1 mt-2"><a href="https://twitter.com/gtalarico">Gui Talarico</a></h3>
      <p>
        Architect turned developer and creator of
        <a href="https://revitapidocs.com">revitapidocs.com</a>
        and
        <a href="https://apidocs.co">apidocs.co</a>
        . Gui is responsible for the overall vision, backend, and for introducing many frontend
        bugs.
      </p>

      <h3 class="mb-1 mt-2"><a href="https://twitter.com/danrocc">Daniel da Rocha</a></h3>
      <p>
        Architect turned developer and creator of
        <a href="https://remotearchitects.club">remotearchitects.club</a>
        , organizer of
        <a href="https://architecturalnetworks.com/berlin">architecturalnetworks.com/berlin</a>
        , and author of
        <a href="http://theforeignarchitect.com ">theforeignarchitect.com</a>
        . Daniel works primarily on the frontend and is trying hard to undo the mess created by Gui.
      </p>

      <h3 class="mb-1 mt-2"><a href="https://twitter.com/dan__n">Daniel Nguyen</a></h3>
      <p>
        Also an architect turned developer, creator of
        <a href="https://archdictionary.com/">archdictionary.com</a>
        , and is currently doing some really cool stuff at
        <a href="https://monograph.io/">Monograph.</a>
      </p>

      <h3 class="mb-1 mt-2">Other Contributors</h3>
      <p>
        The following people also contributed or provided feedback and advice to guide this project:
      </p>

      <ul class="mt-1">
        <li>
          •
          <a href="https://twitter.com/andrewheumann">Andrew Heumann</a>
        </li>
        <li>
          •
          <a href="https://twitter.com/dr_danieldavis">Daniel Davis</a>
        </li>
        <li>
          •
          <a href="https://twitter.com/idid">Dimitrie Stefanescu</a>
        </li>
        <li>
          •
          <a href="https://twitter.com/eirannejad">Ehsan Iran-Njead</a>
        </li>
        <li>
          •
          <a href="https://twitter.com/eng_mclare">Maryanne Clare</a>
        </li>
        <li>
          •
          <a href="https://www.linkedin.com/in/theresediede/">Therese Diede</a>
        </li>
        <li>
          •
          <a href="https://twitter.com/tywygo">Tyler Goss</a>
        </li>
      </ul>

      <h2>Content Quality</h2>

      <p>
        We believe the value of
        <strong>aec.works</strong>
        is not on the platform itself but in the community of editors and content curators.
      </p>
      <p>
        <strong>aec.works</strong>
        it is not intended to be a comprehensive list of every AEC company – rather, it is a
        selected list of companies that our editors consider fresh and exciting.
      </p>
      <p>
        It should be a place people go to to discover disruptive products and who is innovating in
        different spheres of the AEC industry.
      </p>
      <p>
        If you are interested in becoming an editor just send us a note at
        <a href="mailto:team@aec.works">team@aec.works</a>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'About',
  metaInfo: {
    title: 'About',
  },
}
</script>
